// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-popup-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999 !important;
  background: transparent;
  pointer-events: auto;
}

.cell-popup {
  position: fixed !important;
  background: #000000;
  border: 1px solid #ffffff;
  border-radius: 0;
  padding: 1rem;
  min-width: 300px;
  max-width: 600px;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 0 0 1px #ffffff;
  z-index: 999999 !important;
  pointer-events: auto;
  scrollbar-width: thin;
  scrollbar-color: #ffffff transparent;
}

.cell-popup::-webkit-scrollbar {
  width: 6px;
}

.cell-popup::-webkit-scrollbar-track {
  background: transparent;
}

.cell-popup::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border-radius: 0;
}

.cell-popup-close {
  background: transparent !important;
  border: none;
  color: var(--cell-txt-color);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.cell-popup-close:hover {
  background: transparent !important;
  color: var(--primary-color);
}

.cell-popup-content {
  color: var(--cell-txt-color);
  font-size: 0.9rem;
  line-height: 1.6;
}

.cell-popup-content p {
  color: var(--cell-txt-color);
  display: inline;
  margin: 0;
  margin-right: 0.5em;
}

.cell-popup-content p.cell-coords {
  display: block;
  margin-bottom: 0.5em;
  margin-right: 0;
}

.cell-popup-content p:last-child {
  margin-right: 0;
}

.cell-popup-content .book-content {
  display: inline;
  margin-right: 0.5em;
}

.cell-popup-content .figure-detail-view,
.cell-popup-content .figure-detail-view > p,
.cell-popup-content .figure-detail-view > span,
.cell-popup-content > div,
.cell-popup-content > span {
  display: inline;
  margin-right: 0.5em;
}

.cell-popup-content .specs {
  display: inline;
}

.cell-popup-content .specs > * {
  display: inline;
}

.cell-popup-content .book {
  display: inline;
}

.cell-popup-content .book > * {
  display: inline;
}

.cell-popup-content .underground-region-link {
  display: block;
  margin-top: 0.5em;
}

.cell-popup-content .cat_headline {
  color: var(--cell-txt-color);
}

.cell-popup-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.cell-popup-link,
.cell-popup-content a,
.cell-popup-content .inline-entity-link {
  background: none;
  border: none;
  color: var(--primary-color) !important;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font: inherit;
  font-size: inherit;
  line-height: inherit;
  text-align: left;
  display: inline;
}

.cell-popup-link:hover,
.cell-popup-content a:hover,
.cell-popup-content .inline-entity-link:hover {
  color: var(--primary-color);
  text-decoration: underline;
}

.cell-popup-link:active,
.cell-popup-content a:active,
.cell-popup-content .inline-entity-link:active {
  color: var(--primary-color);
}

.cell-popup-separator {
  color: var(--cell-txt-color);
  margin: 0 0.25rem;
}

/* Remove selection highlight */
.cell-popup * {
  -webkit-user-select: none;
  user-select: none;
}

.cell-popup-link {
  -webkit-user-select: none;
  user-select: none;
}

.cell-popup-link::selection {
  background: transparent;
}

.cell-popup-link::-moz-selection {
  background: transparent;
}

/* Remove focus outline */
.cell-popup-link:focus {
  outline: none;
}

.cell-popup-link:focus-visible {
  outline: none;
}

/* Buttons should use cell text color */
.cell-popup-content button {
  color: var(--cell-txt-color);
  background: transparent;
  border: none;
  padding: 0;
  text-align: left;
}

/* Links in RichBookContent should use primary color */
.cell-popup-content .rich-book-content a,
.cell-popup-content .rich-book-content .inline-entity-link,
.cell-popup-content .inline-entity-link {
  color: var(--primary-color) !important;
  text-decoration: underline;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/CellPopup.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;;;EAGE,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".cell-popup-overlay {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999999 !important;\n  background: transparent;\n  pointer-events: auto;\n}\n\n.cell-popup {\n  position: fixed !important;\n  background: #000000;\n  border: 1px solid #ffffff;\n  border-radius: 0;\n  padding: 1rem;\n  min-width: 300px;\n  max-width: 600px;\n  max-height: 70vh;\n  overflow-y: auto;\n  box-shadow: 0 0 0 1px #ffffff;\n  z-index: 999999 !important;\n  pointer-events: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #ffffff transparent;\n}\n\n.cell-popup::-webkit-scrollbar {\n  width: 6px;\n}\n\n.cell-popup::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cell-popup::-webkit-scrollbar-thumb {\n  background-color: #ffffff;\n  border-radius: 0;\n}\n\n.cell-popup-close {\n  background: transparent !important;\n  border: none;\n  color: var(--cell-txt-color);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n}\n\n.cell-popup-close:hover {\n  background: transparent !important;\n  color: var(--primary-color);\n}\n\n.cell-popup-content {\n  color: var(--cell-txt-color);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.cell-popup-content p {\n  color: var(--cell-txt-color);\n  display: inline;\n  margin: 0;\n  margin-right: 0.5em;\n}\n\n.cell-popup-content p.cell-coords {\n  display: block;\n  margin-bottom: 0.5em;\n  margin-right: 0;\n}\n\n.cell-popup-content p:last-child {\n  margin-right: 0;\n}\n\n.cell-popup-content .book-content {\n  display: inline;\n  margin-right: 0.5em;\n}\n\n.cell-popup-content .figure-detail-view,\n.cell-popup-content .figure-detail-view > p,\n.cell-popup-content .figure-detail-view > span,\n.cell-popup-content > div,\n.cell-popup-content > span {\n  display: inline;\n  margin-right: 0.5em;\n}\n\n.cell-popup-content .specs {\n  display: inline;\n}\n\n.cell-popup-content .specs > * {\n  display: inline;\n}\n\n.cell-popup-content .book {\n  display: inline;\n}\n\n.cell-popup-content .book > * {\n  display: inline;\n}\n\n.cell-popup-content .underground-region-link {\n  display: block;\n  margin-top: 0.5em;\n}\n\n.cell-popup-content .cat_headline {\n  color: var(--cell-txt-color);\n}\n\n.cell-popup-text {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.cell-popup-link,\n.cell-popup-content a,\n.cell-popup-content .inline-entity-link {\n  background: none;\n  border: none;\n  color: var(--primary-color) !important;\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0;\n  font: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: left;\n  display: inline;\n}\n\n.cell-popup-link:hover,\n.cell-popup-content a:hover,\n.cell-popup-content .inline-entity-link:hover {\n  color: var(--primary-color);\n  text-decoration: underline;\n}\n\n.cell-popup-link:active,\n.cell-popup-content a:active,\n.cell-popup-content .inline-entity-link:active {\n  color: var(--primary-color);\n}\n\n.cell-popup-separator {\n  color: var(--cell-txt-color);\n  margin: 0 0.25rem;\n}\n\n/* Remove selection highlight */\n.cell-popup * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cell-popup-link {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cell-popup-link::selection {\n  background: transparent;\n}\n\n.cell-popup-link::-moz-selection {\n  background: transparent;\n}\n\n/* Remove focus outline */\n.cell-popup-link:focus {\n  outline: none;\n}\n\n.cell-popup-link:focus-visible {\n  outline: none;\n}\n\n/* Buttons should use cell text color */\n.cell-popup-content button {\n  color: var(--cell-txt-color);\n  background: transparent;\n  border: none;\n  padding: 0;\n  text-align: left;\n}\n\n/* Links in RichBookContent should use primary color */\n.cell-popup-content .rich-book-content a,\n.cell-popup-content .rich-book-content .inline-entity-link,\n.cell-popup-content .inline-entity-link {\n  color: var(--primary-color) !important;\n  text-decoration: underline;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
